export default {
      id: "bankArrow-usage",
      viewBox: "0 0 12 8",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#bankArrow-usage",
      toString: function () {
        return this.url;
      }
    }